import { Flex, Text } from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";

interface DatepickerWithLabelProps {
  label: string;
  date: any;
  onDateChange: (dt: any) => void;
}

const Datepicker: React.FC<DatepickerWithLabelProps> = ({
  label,
  date,
  onDateChange,
}) => (
  <Flex display="flex" align="center">
    <Text mr={2}>{label}</Text>
    <SingleDatepicker
      date={date}
      onDateChange={(dt: any) => onDateChange(dt)}
      name="date-input"
      id={"jdsklf"}
      configs={{
        dateFormat: "dd-MM-yyyy",
      }}
      propsConfigs={{
        dayOfMonthBtnProps: {
          defaultBtnProps: {
            // borderColor: "red.300",
            _hover: {
              background: 'teal.300',
            }
          },
          selectedBtnProps: {
            background: "teal.400",
          },
          todayBtnProps: {
            background: "teal.400",
          }
        } as any, // Use 'as any' to bypass type checking temporarily
        inputProps: {
          size: "sm",
          style: {
            width: "7rem", // Set the width of the input element
          },
        },
      }}
    />
  </Flex>
);

export default Datepicker;
